export const fileMenuItem = `<li id="li_tabFile" style="opacity: 1; pointer-events: initial;">
    <a id="tabFile" rel="ribbonTabFile" data-text="File" tabindex="-1"><div class="txTabTextContainer">File</div></a></li>`;

export const txdocsMenuItem = `<li id="li_tabTxdocs" style="opacity: 1; pointer-events: initial;">
    <a id="tabTxdocs" rel="ribbonTabTxdocs" data-text="TXdocs" tabindex="-1">
        <div class="txTabTextContainer">
            TXdocs
        </div>
    </a>
</li>
`;

export const fileTab = `
<div class="tab-content" id="ribbonTabFile" style="display: none;">
  <div id="ribbonGroupActions" class="ribbon-group"></div>
</div>`;

export const txdocsTab = `<div class="tab-content txdocs-ribbon-bar" id="ribbonTabTxdocs" style="display: none;"></div>`;
export const eventsToTrack = [
  'charFormatChanged',
  'chartCreated',
  'chartDeleted',
  'chartDeselected',
  'chartSelected',
  'commentChanged',
  'commentedTextEntered',
  'commentedTextLeft',
  'commentStateChanged',
  'contextMenuOpening',
  'documentLinkClicked',
  'documentLoaded',
  'documentSizeChanged',
  'drawingActivated',
  'drawingCreated',
  'drawingDeactivated',
  'drawingDeleted',
  'drawingDeselected',
  'drawingSelected',
  'editableRegionCreated',
  'editableRegionDeleted',
  'editableRegionEntered',
  'editableRegionLeft',
  'fileDropped',
  'formFieldCheckChanged',
  'formFieldDateChanged',
  'formFieldSelectionChanged',
  'formFieldTextChanged',
  'frameDeselected',
  'frameSelected',
  'headerFooterActivated',
  'headerFooterDeactivated',
  'hypertextLinkClicked',
  'hyphenateWord',
  'imageCreated',
  'imageDeleted',
  'imageDeselected',
  'imageSelected',
  'mainTextActivated',
  'pageFormatChanged',
  'paragraphFormatChanged',
  'removeCombobox',
  'ribbonTabIndexChanged',
  'signatureFieldCreated',
  'signatureFieldDeleted',
  'signatureFieldDeselected',
  'signatureFieldSelected',
  'spellCheckText',
  'subTextPartCreated',
  'subTextPartDeleted',
  'subTextPartClicked',
  'subTextPartDoubleClicked',
  'subTextPartEntered',
  'subTextPartLeft',
  'tableCreated',
  'tableDeleted',
  'tableOfContentsCreated',
  'tableOfContentsDeleted',
  'tableOfContentsEntered',
  'tableOfContentsLeft',
  'textDropped',
  'textFieldClicked',
  'textFieldCreated',
  'textFieldDeleted',
  'textFieldEntered',
  'textFieldLeft',
  'textPasted',
  'textFrameActivated',
  'textFrameCreated',
  'textFrameDeactivated',
  'textFrameDeleted',
  'textFrameDeselected',
  'textFrameSelected',
  'trackedChangeChanged',
  'trackedChangeCreated',
  'trackedChangeDeleted',
  'trackedChangeStateChanged',
  'textViewLocationChanged',
  'webSocketClosed',
  'zoomFactorChanged',
  'unhandledError',
];
